import React, { Fragment } from "react";

const Skill = () => {
  return (
    <Fragment>
      <div className="skills-progress skills">
        <div className="habilidades_contenedor">
          <div className="codeconSkills">
            <div className="codeconSkillbar mb-80 md-mb-60">
              <div className="skill-text">
                <span className="codeconSkillArea">SKIll</span>
              </div>
              <div
                className="skillBar"
                data-percent="93%"
                style={{
                  background: "#F25DFF",
                }}
              >
                <span className="PercentText">93%</span>
              </div>
            </div>
            <div className="codeconSkillbar mb-80 md-mb-60">
              <div className="skill-text">
                <span className="codeconSkillArea">Efficiency</span>
              </div>
              <div
                className="skillBar"
                data-percent="96%"
                style={{
                  background: "blue",
                }}
              >
                <span className="PercentText">95%</span>
              </div>
            </div>
            <div className="codeconSkillbar mb-80 md-mb-60">
              <div className="skill-text">
                <span className="codeconSkillArea">Accuracy</span>
              </div>
              <div
                className="skillBar"
                data-percent="92%"
                style={{
                  background: "yellow",
                }}
              >
                <span className="PercentText">92%</span>
              </div>
            </div>
            <div className="codeconSkillbar skill-2">
              <div className="skill-text">
                <span className="codeconSkillArea ">Performance</span>
              </div>
              <div
                className="skillBar"
                data-percent="98%"
                style={{
                  background: "#00E8FA",
                }}
              >
                <span className="PercentText">98%</span>
              </div>
            </div>
          </div>
          {/* /.codeconSkills */}
        </div>

        {/* /.habilidades_contenedor */}
      </div>
    </Fragment>
  );
};

export default Skill;
